import { useEffect, useState } from "react";
import { Spinner100 } from "../../components/icons/SvgIcons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/navbar/navbarComponent";
import { ActionCircleIcon } from "../../components/icons/SvgIcons";
import { getActasJuzgado, searchActa, upActa } from "../../redux/actions";
import { useForm } from "react-hook-form";
import SuccessModal from "../../components/modals/successModal";
import ErrorModal from "../../components/modals/errorModal";
import InformarIngresoComponent from "./informarIngreso";

function IngresoComponent() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [loadingSearchActa, setLoadingSearchActa] = useState(false);
  const [actasJuzgado, setActasJuzgado] = useState([]);
  const [juzgadoError, setJuzgadoError] = useState(null);
  const [secuestroId, setSecuestroId] = useState("");
  const tipoCurrentUser = useSelector((state) => state.tipoCurrentUser);

  const handleBackClick = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchActasJuzgado = async () => {
      try {
        const { data } = await dispatch(getActasJuzgado());
        setActasJuzgado(data);
      } catch (error) {
        if (error?.response?.status === 502) {
          setJuzgadoError("El servidor del juzgado no está disponible en este momento.");
        } else {
          setJuzgadoError("Ocurrió un error al cargar las actas del juzgado.");
        }

      } finally {
        setLoading(false);
      }
    };
    fetchActasJuzgado();
  }, [dispatch]);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoadingSearchActa(true)
    const response = await dispatch(searchActa(data.nroActa));

    if (!response) {
      navigate("/ingreso_detalles");
      setLoadingSearchActa(false)
    } else if (typeof response === "number") { //Si la respuesta es un nro, es el id del secuestro con ese nro de acta
      setError("nroActa", {
        type: "server",
        message: "Este número de acta ya fue ingresado al corralón",
      });
      setSecuestroId(response);
      setLoadingSearchActa(false)
    } else {
      setError("nroActa", {
        type: "server",
        message: response || "Error desconocido",
      });
      setLoadingSearchActa(false)
    }
  };
  
  const handleSubmitJuzgado = async (acta) => {
    await dispatch(upActa(acta));
    navigate("/ingreso_detalles");
  };

  const handleVerIngreso = async () => {
    navigate(`/detail/${secuestroId}`);
  };

  const [isModalInformarOpen, setIsModalInformarOpen] = useState(false);

  const openModalInformar = () => setIsModalInformarOpen(true);
  const closeModalInformar = () => setIsModalInformarOpen(false);

  const [mostrarModalExito, setMostrarModalExito] = useState(false);
  const [mostrarModalError, setMostrarModalError] = useState(false);

  const [mensajeError, setMensajeError] = useState("Ocurrió un error");

  return (
    <div className="bg-[#F5FAFF]">
      <Navbar />

      <button
        onClick={handleBackClick}
        className="z-50 absolute top-28 left-12 sm:top-28 sm:left-20 lg:left-52
               flex items-center justify-center p-2 rounded-full
               hover:drop-shadow-[3px_3px_5px_rgba(0,0,0,0.3)]
               transition ease-in-out duration-200"
      >
        <ActionCircleIcon className="flex flex-start h-12 drop-shadow-[2px_2px_4px_rgba(0,0,0,0.3)]" />
      </button>

      {/* Render condicional para informar ingreso */}
      {isModalInformarOpen && actasJuzgado && (
        <InformarIngresoComponent
          onCloseInformar={closeModalInformar}
          actasJuzgado={actasJuzgado}
          openSuccessModal={() => {
            closeModalInformar()
            setMostrarModalExito(true);
          }}
          openErrorModal={(mensaje) => {
            closeModalInformar()
            setMensajeError(mensaje);
            setMostrarModalError(true);
          }}
        />
      )}

      {mostrarModalExito && (
        <SuccessModal closeSuccessModal={() => {
          setMostrarModalExito(false);
          navigate(0)
        }} />
      )}
      {mostrarModalError && (
        <ErrorModal closeErrorModal={() => setMostrarModalError(false)} message={mensajeError} />
      )}


      <div className="flex  flex-col items-center min-h-screen w-full h-full gap-8">
        <div className="flex flex-col justify-center items-start sm:items-center mt-[5rem] sm:mt-[4rem] w-[20rem] sm:w-[32rem]">
          <div className="text-[#3d4245] sm:text-[2rem] text-[1rem] font-bold font-inter">
            Nuevo ingreso
          </div>
          <div className="text-[#687073] sm:text-lg text-s font-medium font-inter">
            Ingresa un nuevo vehículo al corralón
          </div>
        </div>

        <div className="w-[20rem] sm:w-[32rem] h-[56.40px] flex-col justify-start items-start gap-1 inline-flex mb-1 sm:mb-5">
          <div className="self-stretch justify-start items-center inline-flex">
            <div className="w-[33.40px] h-[33.40px] p-[3.34px] bg-[#c5dfff] rounded-[33.40px] border-2 border-[#0477ad]"></div>
            <div className="grow shrink basis-0 h-[2.50px] bg-[#0477ad]"></div>
            <div className="w-[33.40px] h-[33.40px] p-[3.34px] rounded-[33.40px] border-2 border-[#0477ad]"></div>
            <div className="grow shrink basis-0 h-[2.50px] bg-[#0477ad]"></div>
            <div className="w-[33.40px] h-[33.40px] p-[3.34px] rounded-[33.40px] border-2 border-[#0477ad]"></div>
          </div>
          <div className="self-stretch px-1 justify-between items-start inline-flex">
            <div className="text-[#3d4245] text-base font-semibold font-inter">
              Acta
            </div>
            <div className="text-[#3d4245] text-base font-semibold font-inter">
              Detalles
            </div>
            <div className="text-[#3d4245] text-base font-semibold font-inter">
              Foto
            </div>
          </div>
        </div>


        <div className=" justify-center w-[20rem] sm:w-[32rem] flex-col items-start gap-1  mb-1 sm:mb-5">

          <div className="text-[#687073] sm:text-lg text-s font-medium font-inter text-center justify-center">
            Buscar un nro de acta
          </div>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-[20rem] sm:w-[32rem] h-[75px] justify-start items-end gap-2 inline-flex"
          >
            <div className="grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
              <div className="text-[#3d4245] text-sm font-normal font-inter">
                N° acta
              </div>

              <input
                name="nroActa"
                type="number"
                className=" w-full  text-sm font-normal font-inter outline-none rounded-md pl-4 pr-10 py-2 h-[50px]"
                {...register("nroActa", {
                  required: "Ingrese un número de acta por favor",
                  validate: (value) => {
                    if (isNaN(value)) return "Debe ser un número válido";
                    if (!/^\d+$/.test(value))
                      return "Debe ser un número válido y entero";
                    if (Number(value) <= 0) return "El número debe ser mayor a 0";
                    if (value.length > 10)
                      return "El número es demasiado largo para ser válido";
                    return true; // Válido
                  },
                })}
                placeholder="0"
                style={{
                  MozAppearance: "textfield",
                  WebkitAppearance: "none",
                }}
              />
            </div>
            <button
              type="submit"
              className="w-[118px] h-[50px] px-[18px] py-[13px] bg-[#0477ad] rounded-lg justify-center items-center gap-1 flex"
              disabled={loadingSearchActa}
            >
              {loadingSearchActa ? (
                <Spinner100 className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-white" />
              ) : (
                <div className="text-[#f6f5f5] text-base font-semibold font-inter">
                  Buscar
                </div>
              )}
            </button>
          </form>
          {errors.nroActa && (
            <p className="text-red-500">{errors.nroActa.message}</p>
          )}
          {errors.nroActa?.message ===
            "Este número de acta ya fue ingresado al corralón" && (
              <button
                onClick={handleVerIngreso}
                className="text-blue-500 justify-center items-center text-center"
              >
                Ver ingreso
              </button>
            )}
          <div className="bg-[#F5FAFF] w-full">
            <div className="flex flex-col justify-center items-start sm:items-center mt-[2rem]  w-[20rem] sm:w-[32rem] ">

              <div className="text-[#687073] sm:text-lg text-s font-medium font-inter">
                O buscar entre las últimas actas ingresadas en juzgado
              </div>

              <div className="flex flex-wrap gap-5 my-[2rem]  w-[20rem] sm:w-[32rem]">
                {loading ? (
                  <div>Cargando actas...</div>
                ) : juzgadoError ? (
                  <div className="text-red-600 text-sm sm:text-base font-medium mt-2">
                    ⚠️ {juzgadoError}
                  </div>
                ) : actasJuzgado.length === 0 ? (
                  <div className="text-[#3d4245] text-sm sm:text-base font-medium mt-2">
                    ⚠️ No hay actas cargadas en juzgado en los últimos 30 dias
                  </div>
                ) : (
                  actasJuzgado.map((acta) =>
                    <button onClick={() => handleSubmitJuzgado(acta)} key={acta.nroActa} className="inline-flex items-center rounded-md bg-[#F5FAFF] px-2 py-1 text-3xl font-medium text-[#0477ad] ring-1 ring-[#0477ad] ring-inset">
                      {acta.nroActa}
                    </button>
                  ))}
              </div>

              {actasJuzgado.length !== 0 && tipoCurrentUser !== "user" ? (
                <div className="text-[#687073] sm:text-lg text-s font-medium font-inter flex justify-center items-center gap-3">
                  Uno de estos números de acta ya ingresó?
                  <button
                    type="submit"
                    className="w-[118px] h-[50px] px-[18px] py-[13px] bg-[#0477ad] rounded-lg justify-center items-center gap-1 flex"
                    onClick={openModalInformar}
                  >
                    <div className="text-[#f6f5f5] text-base font-semibold font-inter">
                      Informar
                    </div>
                  </button>
                </div>
              ) : (null)}


            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IngresoComponent;
